// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x4UO","importantInfo":"styles_importantInfo__1BGto"};